/* eslint max-classes-per-file: 0 */

import { AxiosRequestConfig } from 'axios'
import {
  Participant as Data,
  ParticipantCollection as Collection,
  ParticipantsUsersCollection,
  ParticipantUserCollection,
} from '@/typings/api/Participant'
import { BaseApiParams as BP, BaseApiResponse } from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export const enum ImportConfirm {
  new = 'NEW',
  append = 'APPEND',
  replace = 'REPLACE',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ImportConfirmData =
  | {
    column_index: number;
    mode: ImportConfirm.new;
    title: string;
    participants_id: never;
  } | {
    column_index: number;
    mode: ImportConfirm.append | ImportConfirm.replace;
    title: never;
    participants_id: number;
  }

export class ParticipantsApi extends BaseApiAuth<Data, Collection, BP> {
  protected readonly endpoint = 'participants/participants';

  public copy(id: Data['id'], data?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/copy/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public addAte(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/add-ate/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public removeAte(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/remove-ate/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public getRegions(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/regions/`
    const [url, params2] = this.getUrl(path, params)
    return this.request('GET', url, { params: params2, ...config })
  }

  public getMunicipalities(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/municipalities/`
    const [url, params2] = this.getUrl(path, params)
    return this.request('GET', url, { params: params2, ...config })
  }

  public getSchools(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/schools/`
    const [url, params2] = this.getUrl(path, params)
    return this.request('GET', url, { params: params2, ...config })
  }

  public getCount(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/count/`
    const [url, params2] = this.getUrl(path, params)
    return this.request('GET', url, { params: params2, ...config })
  }

  public getListForCopy(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/list-ate/`
    const [url, params2] = this.getUrl(path, params)
    return this.request('GET', url, { params: params2, ...config })
  }

  public import(file: File, params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'import/'
    const [url, params2] = this.getUrl(path, params)
    const data = new FormData()
    data.append('file', file)
    const config_n = { params: params2, data, ...config }
    return this.request('POST', url, config_n)
  }

  public export(id: Data['id']) {
    const path = `${id}/report/`
    const [url] = this.getUrl(path)
    return url
  }

  public exportList() {
    const path = 'report/'
    const [url] = this.getUrl(path)
    return url
  }

  public getUsers<R = BaseApiResponse<ParticipantUserCollection>>(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/users/`
    const [url, params2] = this.getUrl(path, params)
    return this.request<never, R>('GET', url, { params: params2, ...config })
  }

  public addUser(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/add-user/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public removeUser(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/remove-user/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }
}

export class ParticipantsUsersApi extends BaseApiAuth<ParticipantsUsersCollection, ParticipantsUsersCollection> {
  protected readonly endpoint = 'participants/participants/:participants_id/users';
}
